import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import { ReactNode } from 'react';
import { useResultRowBaseStyles } from './resultRowBase.styles';

interface ResultRowBaseProps {
  testId?: string;
  onClick: () => void;
  leading: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  line1Trailing?: ReactNode;
  trailing?: ReactNode;
  isActive?: boolean;
  isDisabled?: boolean;
  domId?: string;
}

function ResultRowBase({
  testId,
  onClick,
  leading,
  title,
  subtitle,
  line1Trailing,
  trailing,
  isActive,
  isDisabled,
  domId,
}: ResultRowBaseProps) {
  const isSingleLine = !subtitle;
  const { classes } = useResultRowBaseStyles({ isActive, isDisabled, isSingleLine });

  return (
    <Box
      id={domId}
      role="option"
      aria-selected={isActive}
      aria-disabled={isDisabled}
      onClick={onClick}
      test-id={testId}
      className={classes.root}
    >
      <Stack direction="row" className={classes.contentStack}>
        <Box className={classes.leadingSlot}>{leading}</Box>
        <Stack className={classes.textStack}>
          <Stack direction="row" className={classes.titleRow}>
            <Typography variant="body1" color="text.primary" noWrap className={classes.title}>
              {title}
            </Typography>
            {line1Trailing}
          </Stack>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" noWrap>
              {subtitle}
            </Typography>
          )}
        </Stack>
      </Stack>
      {trailing && <Box className={classes.trailing}>{trailing}</Box>}
    </Box>
  );
}

export default ResultRowBase;
